import toast from 'react-hot-toast';

export const handleImprimirCotizacion = (solicitud, items, extras, total, observaciones) => {
  const printWindow = window.open('', '_blank', 'width=800,height=900');
  if (!printWindow) {
    toast.error('El navegador bloqueó la ventana emergente para imprimir.');
    return;
  }

  const itemsCotizados = (items || []).filter(i => parseFloat(i.valor) > 0);
  const extrasCotizados = (extras || []).filter(e => parseFloat(e.valor) > 0);

  const rowsItems = itemsCotizados.map(item => `
    <tr>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; font-size: 14px;">${item.tipo_documento || '-'}</td>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; font-size: 14px; text-align: right; font-weight: 500;">$${new Intl.NumberFormat('es-CL').format(item.valor)}</td>
    </tr>
  `).join('');

  const rowsExtras = extrasCotizados.map(ex => `
    <tr>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; font-size: 14px;">${ex.descripcion || '-'}</td>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; font-size: 14px; text-align: right; font-weight: 500;">$${new Intl.NumberFormat('es-CL').format(ex.valor)}</td>
    </tr>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Cotización - Solicitud ${solicitud.numero_seguimiento || ''}</title>
        <style>
          body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            color: #0f172a;
            margin: 0;
            padding: 40px;
            background: #fff;
          }
          .header {
            text-align: center;
            margin-bottom: 40px;
            border-bottom: 2px solid #0f172a;
            padding-bottom: 20px;
          }
          .title {
            font-size: 22px;
            font-weight: 800;
            margin: 0 0 5px 0;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .subtitle {
            font-size: 14px;
            color: #64748b;
            text-transform: uppercase;
          }
          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            margin-bottom: 30px;
            background: #f8fafc;
            padding: 20px;
            border-radius: 8px;
            font-size: 13px;
          }
          .info-item {
            margin-bottom: 8px;
          }
          .info-label {
            color: #64748b;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 11px;
            margin-bottom: 2px;
          }
          .info-value {
            font-weight: 500;
            color: #1e293b;
            font-size: 14px;
          }
          .section-title {
            font-size: 16px;
            font-weight: 700;
            color: #0f172a;
            text-transform: uppercase;
            margin-bottom: 15px;
            border-bottom: 1px solid #e2e8f0;
            padding-bottom: 8px;
            margin-top: 30px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          th {
            text-align: left;
            padding: 12px;
            background: #f8fafc;
            color: #475569;
            font-size: 12px;
            text-transform: uppercase;
            border-bottom: 2px solid #e2e8f0;
          }
          .footer {
            text-align: center;
            font-size: 12px;
            color: #94a3b8;
            margin-top: 50px;
            border-top: 1px solid #e2e8f0;
            padding-top: 20px;
          }
          @media print {
            body { padding: 0; }
            .info-grid { background: #fff !important; border: 1px solid #e2e8f0; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1 class="title">Cotización de Solicitud</h1>
          <div class="subtitle">Conservador de Bienes Raíces - San Carlos</div>
        </div>
        
        <div class="info-grid">
          <div>
            <div class="info-item"><div class="info-label">N° de Seguimiento</div><div class="info-value">${solicitud.numero_seguimiento || '-'}</div></div>
            <div class="info-item"><div class="info-label">Fecha de Ingreso</div><div class="info-value">${new Date(solicitud.created_at).toLocaleDateString('es-CL')}</div></div>
          </div>
          <div>
            <div class="info-item"><div class="info-label">Solicitante</div><div class="info-value">${solicitud.nombre_solicitante || '-'}</div></div>
            <div class="info-item"><div class="info-label">RUT</div><div class="info-value">${solicitud.rut_solicitante || '-'}</div></div>
            <div class="info-item"><div class="info-label">Email</div><div class="info-value">${solicitud.email || '-'}</div></div>
          </div>
        </div>

        <div class="section-title">1. Valores por Documento</div>
        ${rowsItems.length > 0 ? `
        <table>
          <thead>
            <tr>
              <th>Detalle / Documento</th>
              <th style="text-align: right; width: 150px;">Precio</th>
            </tr>
          </thead>
          <tbody>
            ${rowsItems}
          </tbody>
        </table>
        ` : '<p style="font-size: 13px; color: #64748b; font-style: italic;">No hay valores definidos por documento.</p>'}

        <div class="section-title">2. Cobros Extras / Especiales</div>
        ${rowsExtras.length > 0 ? `
        <table>
          <thead>
            <tr>
              <th>Descripción</th>
              <th style="text-align: right; width: 150px;">Precio</th>
            </tr>
          </thead>
          <tbody>
            ${rowsExtras}
          </tbody>
        </table>
        ` : '<p style="font-size: 13px; color: #64748b; font-style: italic;">No hay cobros extras definidos.</p>'}

        <div style="background: #f8fafc; padding: 20px; border-radius: 8px; border: 2px solid #0f172a; display: flex; justify-content: space-between; align-items: center; margin-top: 40px;">
          <span style="font-weight: 800; font-size: 16px; color: #0f172a;">TOTAL COTIZACIÓN:</span>
          <span style="font-weight: 800; font-size: 24px; color: #0f172a;">$${new Intl.NumberFormat('es-CL').format(total)}</span>
        </div>

        ${observaciones ? `
          <div class="section-title">Observaciones</div>
          <p style="font-size: 14px; color: #475569; white-space: pre-wrap; font-style: italic;">${observaciones}</p>
        ` : ''}

        <div class="footer">
          Documento generado el ${new Date().toLocaleString('es-CL')}
        </div>
        
        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() { window.close(); }, 500);
          };
        </script>
      </body>
    </html>
  `;
  
  printWindow.document.write(html);
  printWindow.document.close();
};
